import { render, staticRenderFns } from "./Information.vue?vue&type=template&id=d0f9d3ea&scoped=true&lang=pug&"
import script from "./Information.vue?vue&type=script&lang=ts&"
export * from "./Information.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f9d3ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/arc-one/_www/millsta-ready/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0f9d3ea')) {
      api.createRecord('d0f9d3ea', component.options)
    } else {
      api.reload('d0f9d3ea', component.options)
    }
    module.hot.accept("./Information.vue?vue&type=template&id=d0f9d3ea&scoped=true&lang=pug&", function () {
      api.rerender('d0f9d3ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/templates/Information.vue"
export default component.exports